<template>
  <div
    v-if="hasPropertyService"
    class="col-xl-6"
  >
    <div
      id="statsPanelPortlet"
      :ref="'statsPanelPortlet'"
      :m-portlet="'true'"
      class="m-portlet m-portlet--rounded m-portlet--head-sm"
    >
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text">
              {{ $t("homepage.stats.YourProperties") }}
            </h3>
          </div>
        </div>
        <div class="m-portlet__head-tools pull-right">
          <ul class="m-portlet__nav">
            <li class="m-portlet__nav-item">
              <a
                href="javascript:"
                class="m-portlet__nav-link m-portlet__nav-link--icon"
                @click="loadProperties()"
              >
                <i class="la la-refresh" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="m-portlet__body m-widget14">
        <div class="row">
          <div class="container pb-1 pt-2">
            <div class="row">
              <div class="col-lg col-6 myb-md-4 text-center">
                <h3
                  class="m-widget14__title"
                >
                  <span
                    v-if="featuredService.MaxFeaturedPremium === 0"
                    style="color: #da4d51"
                  >0</span>
                  <span
                    v-else-if="featuredService.MaxFeaturedPremium > 0 && featuredService.MaxFeaturedPremium > premiumFeatured"
                    style="color: #da4d51"
                  >
                    {{ premiumFeatured }}/{{ featuredService.MaxFeaturedPremium }}
                  </span>
                  <span
                    v-else
                    style="color: #34bfa3"
                  >
                    {{ premiumFeatured }}/{{ featuredService.MaxFeaturedPremium }}
                  </span>
                </h3>
                <span class="m-widget14__desc">
                  {{ $t("homepage.stats.PremiumFeatured") }}
                </span>
              </div>

              <div class="col-lg col-6 myb-md-4 text-center">
                <h3 class="m-widget14__title">
                  <span
                    v-if="featuredService.MaxFeaturedStandard === 0"
                    style="color: #da4d51"
                  >0</span>
                  <span
                    v-else-if="featuredService.MaxFeaturedStandard > 0 && featuredService.MaxFeaturedStandard > featured"
                    style="color: #da4d51"
                  >
                    {{ featured }}/{{ featuredService.MaxFeaturedStandard }}
                  </span>
                  <span
                    v-else
                    style="color: #34bfa3"
                  >
                    {{ featured }}/{{ featuredService.MaxFeaturedStandard }}
                  </span>
                </h3>
                <span class="m-widget14__desc">
                  {{ $t("homepage.stats.FeaturedProperties") }}
                </span>
              </div>

              <div class="col-lg col-6 text-center">
                <h3 class="m-widget14__title">
                  <span
                    v-if="propertyService.PropertyLimit === 0"
                    style="color: #da4d51"
                  >0</span>
                  <span
                    v-else-if="propertyService.PropertyLimit > 0 && propertyService.PropertyLimit > active"
                    style="color: #da4d51"
                  >
                    {{ active }}/{{ propertyService.PropertyLimit }}
                  </span>
                  <span
                    v-else
                    style="color: #34bfa3"
                  >
                    {{ active }}/{{ propertyService.PropertyLimit }}
                  </span>
                </h3>
                <span class="m-widget14__desc">
                  {{ $t("homepage.stats.ActiveProperties") }}
                </span>
              </div>

              <div class="col-lg col-6 text-center">
                <h3 class="m-widget14__title">
                  {{ deactivated }}
                </h3>
                <span class="m-widget14__desc">
                  {{ $t("homepage.stats.DeActivatedProperties") }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="separata my-4" />

        <div class="row">
          <div class="col">
            <div class="row align-items-center">
              <div class="col">
                <div
                  id="properties_chart"
                  :ref="'properties_chart'"
                  class="m-widget14__chart"
                  style="height: 160px"
                >
                  <div class="m-widget14__stat">
                    {{ active }}
                  </div>
                </div>
              </div>

              <div class="col">
                <div class="m-widget14__legends">
                  <div class="m-widget14__legend legend-sale">
                    <div
                      class="m-widget14__legend-bullet mr-1"
                      style="background-color: #3478cb"
                    />
                    <div class="m-widget14__legend-text d-xs-block">
                      <strong>{{ sale }}</strong>
                      {{ $t("homepage.stats.Sale") }}
                      <div class="small d-inline d-xs-block">
                        ({{ ((sale / active) * 100).toFixed(2) }}%)
                      </div>
                    </div>
                  </div>

                  <div class="m-widget14__legend legend-rent">
                    <div
                      class="m-widget14__legend-bullet mr-1"
                      style="background-color: #85aee0"
                    />
                    <div class="m-widget14__legend-text d-xs-block">
                      <strong>{{ rent }}</strong>
                      {{ $t("homepage.stats.Rent") }}
                      <div class="small d-inline d-xs-block">
                        ({{ ((rent / active) * 100).toFixed(2) }}%)
                      </div>
                    </div>
                  </div>

                  <div class="m-widget14__legend legend-holiday">
                    <div
                      class="m-widget14__legend-bullet mr-1"
                      style="background-color: #d6e4f5"
                    />
                    <div class="m-widget14__legend-text d-xs-block">
                      <strong>{{ holidays }}</strong>
                      {{ $t("homepage.stats.Holidays") }}
                      <div class="small d-inline d-xs-block">
                        ({{ ((holidays / active) * 100).toFixed(2) }}%)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col m-widget24">
            <div class="m-widget24__item">
              <div class="progress m-progress--sm">
                <div
                  class="progress-bar"
                  :style="
                    'width: ' + ((active / propertyService.PropertyLimit) * 100) +
                      '%; background-color:' + usageColor
                  "
                  aria-valuenow="0"
                  aria-valuemin="0"
                  aria-valuemax="100"
                />
              </div>
              <span class="m-widget24__change">
                {{ ((active / propertyService.PropertyLimit) * 100).toFixed(2) }}% {{ $t("homepage.stats.Used") }}
              </span>
              <span
                v-if="(active / propertyService.PropertyLimit) > 1"
                class="m-widget24__promotion"
              >
                <span class="m-badge m-badge--warning m-badge--wide">
                  {{ $t("homepage.stats.PROMOTION") }}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clientapi } from '../../../api-clients/client-api.js';
import Chartist from 'chartist';
import { getUser, getFeaturedService, getPropertyService } from '../../../functions.ts';

let toColor = function( points ) {
    if ( points < 1 ) {
        return '#da4d51';
    } else if ( points > 1 ) {
        return '#ffb822';
    }

    return '#34bfa3';
};

export default {
    name: 'Properties',
    data() {
        return {
            user: {},
            propertyService: {},
            featuredService: {},
            active: 0,
            deactivated: 0,
            featured: 0,
            premiumFeatured: 0,
            sale: 0,
            rent: 0,
            holidays: 0,
        };
    },
    computed: {
        hasPropertyService() {
            let statuses = [ 'ACTIVE', 'ACTIVE_EXPIRED', 'ACTIVE_PENDING', 'ACTIVE_SUSPENDED' ];
            return statuses.includes( this.propertyService.Status );
        },
        usageColor() {
            return toColor( this.active / this.propertyService.PropertyLimit );
        },
    },
    async mounted() {
        this.user = getUser();
        this.propertyService = await getPropertyService();
        this.featuredService = await getFeaturedService();
        if ( this.hasPropertyService ) {
            this.loadProperties();
        }
    },
    methods: {
        async loadProperties() {
            mApp.block( '#statsPanelPortlet', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

            let premiumFeaturedArgs = {
                'Status': 'available',
                'Featured': 'FeaturedPremium',
            };

            let premiumFeatured = clientapi.get( '/property/count', { params: premiumFeaturedArgs } ).then( ( res ) => {
                return res.data.count;
            } );

            let featuredArgs = {
                'Status': 'available',
                'Featured': 'Featured',
            };
            let featured = clientapi.get( '/property/count', { params: featuredArgs } ).then( ( res ) => {
                return res.data.count;
            } );

            let activeArgs = {
                'Status': 'active',
            };
            let active = clientapi.get( '/property/count', { params: activeArgs } ).then( ( res ) => {
                return res.data.count;
            } );

            let deactiveArgs = {
                'Status': 'deactivated',
            };

            let deactived = clientapi.get( '/property/count', { params: deactiveArgs } ).then( ( res ) => {
                return res.data.count;
            } );

            let saleArgs = {
                'Status': 'active',
                'OfferType': 'for-sale',
            };

            let sale = clientapi.get( '/property/count', { params: saleArgs } ).then( ( res ) => {
                return res.data.count;
            } );

            let rentArgs = {
                'Status': 'active',
                'OfferType': 'for-rent',
            };

            let rent = clientapi.get( '/property/count', { params: rentArgs } ).then( ( res ) => {
                return res.data.count;
            } );

            let holidaysArgs = {
                'Status': 'active',
                'OfferType': 'for-holidays',
            };

            let holidays = clientapi.get( '/property/count', { params: holidaysArgs } ).then( ( res ) => {
                return res.data.count;
            } );

            this.premiumFeatured = await premiumFeatured;
            this.featured = await featured;
            this.active = await active;
            this.deactivated = await deactived;
            this.sale = await sale;
            this.rent = await rent;
            this.holidays = await holidays;

            let pieChartSeries = [
                {
                    value: this.sale / this.active * 100,
                    className: 'custom-sale',
                    count: this.sale,
                    meta: {
                        color: '#4382ce',
                        count: this.sale,
                    },
                },
                {
                    value: this.rent / this.active * 100,
                    className: 'custom-rent',
                    count: this.rent,
                    meta: {
                        color: '#a0c0e5',
                        count: this.rent,
                    },
                },
                {
                    value: this.holidays / this.active * 100,
                    className: 'custom-holiday',
                    count: this.holidays,
                    meta: {
                        color: '#00c5dc',
                        count: this.holidays,
                    },
                },
            ];

            let data = { series: pieChartSeries };
            let chartOptions = { donut: true,
                donutWidth: 17,
                showLabel: true };
            let el = document.getElementById( 'properties_chart' );
            if ( el ) {
                new Chartist.Pie( el, data, chartOptions );
            }

            mApp.unblock( '#statsPanelPortlet' );
        },
    },
};
</script>
